// @ts-nocheck
import React from "react";
import rewardIcon from "../../assets/reward-point-icon.svg"
import rewardPointGrowthIcon from "../../assets/reward-points-growth-icon.svg"
import { Button, Spin } from "antd";
import reward_system_routes from "modules/reward-system/route";
const RewardPointsCardView = (props) => {
    const { rewardData, loading, navigateRoute } = props
    return (
        <Spin className="reward-card-spinner" spinning={loading}>
            <div className="reward-points-card-container">
                <div className="rpcc-top-right-circle"></div>
                <div className="rpcc-header-row">
                    <div className="rpcc-header-title-container">
                        <img src={rewardIcon} alt="" />
                        <h4 className="rpcc-header-title">Reward Points</h4>
                    </div>
                    <div className="rpcc-header-new-badge">New</div>
                </div>
                <div className="rpcc-body-row">
                    <div className="rpcc-total-week-achievements">
                        <div className="rpcc-total-points">
                            <div className="rpcc-total-points-value">{rewardData.total_points}</div>
                            Points
                        </div>
                        <div className="rpcc-total-points-label">Reward Points Earned</div>
                        <div className="rpcc-weekly-achievements">
                            <img src={rewardPointGrowthIcon} alt="" />
                            +{rewardData.points_earned_this_week} points earn this week
                        </div>
                    </div>
                    <div className="rpcc-recent-achievements">
                        {
                            rewardData.recent_activities.map((item, index) => <div className="rpcc-recent-achievement-row" key={index}>
                                <div className="rpcc-recent-achievement-action">
                                    <img src={rewardPointGrowthIcon} alt="" />
                                    {item.action}
                                </div>
                                <div className="rpcc-recent-achievement-points">+{item.points} pts</div>
                            </div>)
                        }
                    </div>
                </div>
                <div className="rpcc-footer-row">
                    <Button className="rpcc-detail-page-link" onClick={() => { navigateRoute(reward_system_routes.reward_system_home) }}>
                        VIEW DETAILS
                    </Button>
                </div>
                <div className="rpcc-bottom-left-circle"></div>
            </div>
        </Spin>
    )
}

export default RewardPointsCardView